import React from 'react';
import {

	Grid,

} from '@material-ui/core';

const handleClick = (e) => {

	window.location.href = `/report-plan-school/${e}`

};

const TabelaDados = ({ dados, disabledViewSchool = false }) => {

	return (
		<>
			<Grid item xs={12}>
				<label
					style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '18px', color: '#262930', marginTop: '36px', marginBottom: '16px' }}
				>
					Planos de Aprendizagem gerados entre Escolas
				</label>
			</Grid>
			<table style={{ width: '100%', borderRadius: '4px', borderColor: '#E5E7EB' }}>
				<thead style={{ backgroundColor: '#F7F8FC' }}>
					<tr>
						<th style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '16px', color: '#727780' }}>  ID</th>
						<th style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '16px', color: '#727780' }}>Unidade Escolar</th>
						<th style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '16px', color: '#727780' }}>Quantidade</th>
						{!disabledViewSchool && (
							<th style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '16px', color: '#727780' }}>Visualizar</th>
						)}
					</tr>
				</thead>
				<tbody>
					{dados.map((item) => (
						<tr key={item.id} style={{ fontFamily: 'Public Sans' }}>
							<td style={{ fontFamily: 'Public Sans' }}>{item.escola_id}</td>
							<td style={{ fontFamily: 'Public Sans' }}>{item.escola_nome}</td>
							<td style={{ fontFamily: 'Public Sans' }}>{item.quantidade_planos_aula}</td>
							{!disabledViewSchool && (
								<td onClick={() => handleClick(item.escola_id)}><svg style={{ cursor: 'pointer' }} width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M10 0C10.8594 0 11.7344 0.117188 12.625 0.351562C13.5156 0.601562 14.375 0.945313 15.2031 1.38281C16.0312 1.82031 16.8125 2.35156 17.5469 2.97656C18.2656 3.60156 18.8906 4.30469 19.4219 5.08594C19.625 5.35156 19.7266 5.65625 19.7266 6C19.7266 6.34375 19.625 6.64844 19.4219 6.91406C18.8906 7.69531 18.2656 8.39844 17.5469 9.02344C16.8125 9.64844 16.0312 10.1797 15.2031 10.6172C14.375 11.0547 13.5156 11.3984 12.625 11.6484C11.7344 11.8828 10.8594 12 10 12C9.14062 12 8.26562 11.8828 7.375 11.6484C6.48438 11.3984 5.625 11.0547 4.79688 10.6172C3.96875 10.1797 3.1875 9.64844 2.45312 9.02344C1.73438 8.39844 1.10938 7.69531 0.578125 6.91406C0.375 6.64844 0.273438 6.34375 0.273438 6C0.273438 5.65625 0.375 5.35156 0.578125 5.08594C1.10938 4.30469 1.73438 3.60156 2.45312 2.97656C3.1875 2.35156 3.96875 1.82031 4.79688 1.38281C5.625 0.945313 6.48438 0.601562 7.375 0.351562C8.26562 0.117188 9.14062 0 10 0ZM14.0078 6C14.0078 4.89062 13.6172 3.94531 12.8359 3.16406C12.0547 2.38281 11.1094 1.99219 10 1.99219C8.89062 1.99219 7.94531 2.38281 7.16406 3.16406C6.38281 3.94531 5.99219 4.89062 5.99219 6C5.99219 7.10938 6.38281 8.05469 7.16406 8.83594C7.94531 9.61719 8.89062 10.0078 10 10.0078C11.1094 10.0078 12.0547 9.61719 12.8359 8.83594C13.6172 8.05469 14.0078 7.10938 14.0078 6ZM10 7.99219C9.45312 7.99219 8.98438 7.79688 8.59375 7.40625C8.20312 7.01562 8.00781 6.54688 8.00781 6C8.00781 5.45312 8.20312 4.98438 8.59375 4.59375C8.98438 4.20312 9.45312 4.00781 10 4.00781C10.5469 4.00781 11.0156 4.20312 11.4062 4.59375C11.7969 4.98438 11.9922 5.45312 11.9922 6C11.9922 6.54688 11.7969 7.01562 11.4062 7.40625C11.0156 7.79688 10.5469 7.99219 10 7.99219Z" fill="#727780" />
								</svg></td>
							)}
						</tr>
					))}
				</tbody>
			</table>
		</>
	);
};

export default TabelaDados;
